import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'


Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        title: '博雅数字官网'
      }
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: () => import('@/views/news/list'),
    },
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: () => import('@/views/news/details'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/page/about'),
    },
    {
      path: '/cooperate',
      name: 'cooperate',
      component: () => import('@/views/page/cooperate'),
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () => import('@/views/page/jobs'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/page/contact'),
    },
    {
      path: '/productList',
      name: 'productList',
      component: () => import('@/views/product/list'),
    },
    {
      path: '/productDetails',
      name: 'productDetails',
      component: () => import('@/views/product/details'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js